import config from 'config'

export default [
  {
    id: 3,
    url: `${config.publicPath}/participants-grid/my-participants`,
    urlPrefix: `${config.publicPath}/participants-grid`,
    defaultMessage: 'Participants',
    icon: 'participants',
    message: 'sidebar.participants',
    description: 'This is a backend rebuild of the Participants tab, with minor changes to layout and filters.'
  },
  {
    id: 4,
    url: `${config.publicPath}/leaders-overview`,
    urlPrefix: `${config.publicPath}/leaders-overview`,
    defaultMessage: 'Leaders',
    message: 'sidebar.leaders',
    icon: 'leader',
    description: 'This is a backend rebuild of the Leaders tab.'
  },
  {
    id: 5,
    url: `${config.publicPath}/participants-grid/invited-participants`,
    urlPrefix: `${config.publicPath}/participants-grid`,
    icon: 'participants',
    defaultMessage: 'Invited Participants',
    message: 'pageTitle.invited_participants',
    description: 'New feature for bulk inviting participants.'
  }
]
